import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  HttpMethod_GET_getInstance2m1rvu4d8a2j3 as HttpMethod_GET_getInstance,
  HttpMethod_POST_getInstance3c6ouf174z7cx as HttpMethod_POST_getInstance,
  HttpMethod_PATCH_getInstance2444xhczsg6ri as HttpMethod_PATCH_getInstance,
  HttpMethod_DELETE_getInstance1ayy9xx1uf6c9 as HttpMethod_DELETE_getInstance,
} from '../../../../kiteui-library/com/lightningkite/kiteui/fetch.mjs';
import {
  serializer1cdzkc3mnhoc4 as serializer,
  ListSerializer1hxuk9dx5n9du as ListSerializer,
  serializer1x79l67jvwntn as serializer_0,
  get_nullable197rfua9r7fsz as get_nullable,
  serializer1hu9wv9at41ww as serializer_1,
} from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/builtins/BuiltinSerializers.mjs';
import {
  Companion_instance357q0zxkn8vu9 as Companion_instance,
  Companion_getInstance3nuke4pai11e0 as Companion_getInstance,
  Companion_instance1jgtwyaz4kdue as Companion_instance_0,
  Companion_getInstance1zugja4gs8z3u as Companion_getInstance_0,
  Companion_getInstance6uhn60p4e96h as Companion_getInstance_1,
  Companion_instance2323gbvzg2l6b as Companion_instance_1,
  Companion_instance1jr11iungn4qh as Companion_instance_2,
  Companion_getInstance3dtgneissrfcv as Companion_getInstance_2,
  Companion_getInstancem5ekhykter02 as Companion_getInstance_3,
  Companion_instancem42ud6s3tl46 as Companion_instance_3,
  Companion_instance1n8yqmuuwqhm2 as Companion_instance_4,
  Companion_getInstance2m9opt1pp6vj6 as Companion_getInstance_4,
  Companion_getInstance1am9aucrot1gq as Companion_getInstance_5,
  MonetaryValue3pm7jom4inigc as MonetaryValue,
  Companion_getInstance2vq5qbtte0dqu as Companion_getInstance_6,
  Companion_getInstanceop74a2t78ktp as Companion_getInstance_7,
  Companion_instance7oj7gdhawh9q as Companion_instance_5,
} from '../../../../crowpay-shared/com/crowpay/supportModels.mjs';
import {
  Companion_getInstance2aea3v0bp26v5 as Companion_getInstance_8,
  Companion_getInstance3qf32mccbb2zd as Companion_getInstance_9,
  Companion_getInstance1ezkh7nuucouo as Companion_getInstance_10,
  Companion_getInstance2siu14nwnk7au as Companion_getInstance_11,
  Companion_getInstance1os6jge06wszv as Companion_getInstance_12,
  Companion_getInstance2irbwqyuggdu2 as Companion_getInstance_13,
} from '../../../../crowpay-shared/com/crowpay/reports/reports.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Companion_getInstance3bisd6gjnm0oz as Companion_getInstance_14,
  ApprovedState3hrsq7yllchx0 as ApprovedState,
  Companion_getInstance307sotgyzbnou as Companion_getInstance_15,
  ChangeRequesthd3ysa2j1i4f as ChangeRequest,
  Companion_getInstance124t3fbljdbyi as Companion_getInstance_16,
  Clientuccelyr89ch8 as Client,
  Companion_getInstance1z8if8hzu5ng5 as Companion_getInstance_17,
  CompletionMessageComment2phagw82v6lch as CompletionMessageComment,
  Companion_getInstance1b21bhtdgqkve as Companion_getInstance_18,
  Contractor1wog4uk4l8u77 as Contractor,
  Companion_getInstance3r9dph6rgwho0 as Companion_getInstance_19,
  ContractorDocument2jcw9hqg98amj as ContractorDocument,
  Companion_getInstance12ven2xbljkm0 as Companion_getInstance_20,
  ContractorNote59o6kpmrrw5h as ContractorNote,
  Companion_getInstancefq4vwlyjorqo as Companion_getInstance_21,
  CrowPayLegalDocumentvhqnf9xycsrg as CrowPayLegalDocument,
  Companion_getInstanceh1cmko92158x as Companion_getInstance_22,
  Dispute39kejofcwuxch as Dispute,
  Companion_instancevwupp4fz0ehs as Companion_instance_6,
  EntityType3jq9a4zvbs0nt as EntityType,
  Companion_getInstancexfdqyjk2ykmw as Companion_getInstance_23,
  FundsRequesthksopls9wk01 as FundsRequest,
  Companion_getInstance12sgbyys5mml7 as Companion_getInstance_24,
  Incident3aojs8cp7629c as Incident,
  Companion_getInstancezuwazqbeik8p as Companion_getInstance_25,
  IncidentMessage1zg9aeg4hgwtu as IncidentMessage,
  Companion_getInstance1up45os1rj3ws as Companion_getInstance_26,
  IncidentMessageComment1adwwkgdgyo0h as IncidentMessageComment,
  Companion_getInstance20myouriyv3u as Companion_getInstance_27,
  ItemChangee3c665suy3yz as ItemChange,
  Companion_getInstance1t0noik4ocb5x as Companion_getInstance_28,
  LegalDocumentAgreement2jq7u4nlw18u as LegalDocumentAgreement,
  Companion_getInstancee6k6ib2dkotb as Companion_getInstance_29,
  License2dabzwgw7jcr2 as License,
  Companion_getInstancex3rnna8pnr6f as Companion_getInstance_30,
  LineItem2rt64afaiyloc as LineItem,
  Companion_getInstance1moufct3sbct9 as Companion_getInstance_31,
  LineItemCompletionMessage2zpi6q6jke1no as LineItemCompletionMessage,
  Companion_getInstance19tkudxb52ql0 as Companion_getInstance_32,
  MailCheckPhysicallytriaqfbh0a67 as MailCheckPhysically,
  Companion_getInstance28gwov6pby7lz as Companion_getInstance_33,
  PayAppItemz8p3l02jgtr9 as PayAppItem,
  Companion_getInstance1h9pz6hxur4uj as Companion_getInstance_34,
  PayApplicationmbkdcq3ut87x as PayApplication,
  Companion_getInstance39he8wfhznx8z as Companion_getInstance_35,
  Payout257apsotr6b9a as Payout,
  Companion_getInstance30idiynnpnbn2 as Companion_getInstance_36,
  PendingItemChange1hwhwykx2kyit as PendingItemChange,
  Companion_getInstance14mfei2uzw3x6 as Companion_getInstance_37,
  PendingLineItem7uj25viy3ie8 as PendingLineItem,
  Companion_getInstance1cdih9ztewhpv as Companion_getInstance_38,
  Companion_getInstance2m617r7l2yg9j as Companion_getInstance_39,
  Companion_instance3cy7oygvo3vp5 as Companion_instance_7,
  Companion_getInstance3g7lwy1meor8x as Companion_getInstance_40,
  Projecto73xqbcrzskm as Project,
  ProjectLedgerItem1yul4cns1huli as ProjectLedgerItem,
  Companion_getInstance1cc7a4v9g7e6l as Companion_getInstance_41,
  ProjectMessage3vmbacgk5u7x3 as ProjectMessage,
  Companion_getInstance3ar1by5trsbn7 as Companion_getInstance_42,
  ProjectSettlementDocumentation1o22wkmr8w8uo as ProjectSettlementDocumentation,
  Companion_getInstance3lubwpz5lc00p as Companion_getInstance_43,
  ProjectTimerh0tihs6u35t6 as ProjectTimer,
  Companion_getInstance2eaghgpohvp5v as Companion_getInstance_44,
  PunchListItem1wbu5dz9rlo4k as PunchListItem,
  Companion_getInstanceha7z78i7nvow as Companion_getInstance_45,
  ScopeView2pjeasrtqdymw as ScopeView,
  Companion_getInstance11rxtahezlto7 as Companion_getInstance_46,
  Specification3fgfbf7ihgj8v as Specification,
  Companion_instance2x6o1nijtl11 as Companion_instance_8,
  Trade15v4llu79udze as Trade,
  Companion_getInstance241hfcdeiz4z5 as Companion_getInstance_47,
  UnlockProjectRequestsb9zq5gbmeux as UnlockProjectRequest,
  Companion_getInstance21u335vgn0mpe as Companion_getInstance_48,
  User8yb1tqk4kykg as User,
} from '../../../../crowpay-shared/com/crowpay/databaseModels.mjs';
import {
  Companion_getInstance1i8v5a4alj7fe as Companion_getInstance_49,
  State3dw676r1r3e8w as State,
  ReportType15553nfaf02up as ReportType,
} from '../../../../crowpay-shared/com/crowpay/enums.mjs';
import {
  ClientModelRestEndpointsLive3jcski6s83sw3 as ClientModelRestEndpointsLive,
  ClientModelRestEndpointsPlusUpdatesWebsocketLivefh363mjnrhnn as ClientModelRestEndpointsPlusUpdatesWebsocketLive,
} from '../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/db/ClientModelRestEndpointsLive.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { ClientModelRestEndpointsuzria74ft4w4 as ClientModelRestEndpoints } from '../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/db/ClientModelRestEndpoints.mjs';
import { UUID21wrnrlmk5y1y as UUID } from '../../../../lightning-server-shared/com/lightningkite/UUID.js.mjs';
import { getKClass3t8tygqu4lcxf as getKClass } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/reflection.mjs';
import { ContextualSerializer1uidivg94sh5v as ContextualSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/ContextualSerializer.mjs';
import {
  HasReadByEndpointsLive3vmvwhttt3ssi as HasReadByEndpointsLive,
  HasReadByWithCreditsEndpointsLive17nkdcbe2canp as HasReadByWithCreditsEndpointsLive,
  HasReadByWithFeedbackEndpointsLive1r08wwk6n4a50 as HasReadByWithFeedbackEndpointsLive,
} from './HasReadByEndpointsLive.mjs';
import { get_DefaultStringArrayFormatk3qh72vmys6l as get_DefaultStringArrayFormat } from '../../../../lightning-server-kiteui-client/com/lightningkite/serialization/urlify.mjs';
import { arrayOf1akklvh2at202 as arrayOf } from '../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import { createKType31ecntyyaay3k as createKType } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/KTypeHelpers.mjs';
import { serializer1i4e9ym37oxmo as serializer_2 } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/Serializers.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import {
  StringCompanionObject_instance3alxothmy382k as StringCompanionObject_instance,
  IntCompanionObject_instance3tw56cgyd5vup as IntCompanionObject_instance,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/internal/primitiveCompanionObjects.mjs';
import { ClientModelRestEndpointsPlusUpdatesWebsocket34r6fusayskwn as ClientModelRestEndpointsPlusUpdatesWebsocket } from '../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/db/deprecated.mjs';
import { Companion_instance3dz2aen8k3fc7 as Companion_instance_9 } from '../../../../lightning-server-shared/com/lightningkite/lightningserver/files/UploadEarlyEndpointModels.mjs';
import {
  Companion_getInstancesldiilhozd0o as Companion_getInstance_50,
  EmailAddress1n0o8cqqfp9qz as EmailAddress,
} from '../../../../lightning-server-shared/com/lightningkite/StringAlts.mjs';
import { PrimitiveClasses_getInstance2v63zn04dtq03 as PrimitiveClasses_getInstance } from '../../../../kotlin-kotlin-stdlib/kotlin/reflect/js/internal/primitives.mjs';
import {
  EmailProofClientEndpointsLive1alityxkq35k4 as EmailProofClientEndpointsLive,
  AuthenticatedOneTimePasswordProofClientEndpointsLivexna614349rpo as AuthenticatedOneTimePasswordProofClientEndpointsLive,
  OneTimePasswordProofClientEndpointsLive38lkvnjxnx70k as OneTimePasswordProofClientEndpointsLive,
  SmsProofClientEndpointsLive2ouvb5xuxwhln as SmsProofClientEndpointsLive,
  UserAuthClientEndpointsLive3v3qnidsvrhq as UserAuthClientEndpointsLive,
  AuthenticatedUserAuthClientEndpointsLive1zz0879mg87jo as AuthenticatedUserAuthClientEndpointsLive,
} from '../../../../lightning-server-kiteui-client/com/lightningkite/lightningserver/auth/authInterfaces.mjs';
import {
  Companion_getInstance2a6946bmnnmyk as Companion_getInstance_51,
  Companion_getInstance23zmguv2nlvyd as Companion_getInstance_52,
  EventSubscription13rxmq485x98c as EventSubscription,
  UserEventType3ayinm14vltts as UserEventType,
  Companion_getInstance2tq82jyrde4r as Companion_getInstance_53,
  Notification36ye7lys64zyi as Notification,
} from '../../../../crowpay-shared/com/crowpay/notifications/shared.mjs';
import {
  Companion_getInstance1plstrcui6kcy as Companion_getInstance_54,
  FunnelInstance3u6ziddd47o20 as FunnelInstance,
  Companion_getInstance35jta5xdhkpv2 as Companion_getInstance_55,
  FunnelSummary2xkqtzvrnqmvn as FunnelSummary,
} from '../../../../lightning-server-shared/com/lightningkite/lightningserver/monitoring/models.mjs';
import {
  Companion_getInstance139kwuiq3xn4y as Companion_getInstance_56,
  OtpSecret2919vqlwy0it0 as OtpSecret,
} from '../../../../lightning-server-shared/com/lightningkite/lightningserver/auth/proof/AuthSecrets.mjs';
import { Instant3cn81rq2kpflk as Instant } from '../../../../Kotlin-DateTime-library-kotlinx-datetime/kotlinx/datetime/Instant.mjs';
import {
  Companion_getInstancelcczxht3hulj as Companion_getInstance_57,
  Companion_instance9tm2i64vxmrs as Companion_instance_10,
} from '../../../../crowpay-shared/com/crowpay/paymentModels.mjs';
import { Companion_getInstance24vxhhaq3p126 as Companion_getInstance_58 } from '../../../../lightning-server-shared/com/lightningkite/lightningserver/auth/proof/proofModels.mjs';
import { Companion_getInstance2cg5mffg7iayj as Companion_getInstance_59 } from '../../../../lightning-server-shared/com/lightningkite/lightningdb/EntryChange.mjs';
import {
  Companion_getInstance1dz3q9fvss53i as Companion_getInstance_60,
  Sessionjhz9dr2n4d55 as Session,
} from '../../../../lightning-server-shared/com/lightningkite/lightningserver/auth/subject/subjectModels.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_delete__spiywt($this, id, $completion) {
  var tmp = $this.cfa_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_0($this, id, $completion) {
  var tmp = $this.efa_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_1($this, id, $completion) {
  var tmp = $this.ifa_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_2($this, id, $completion) {
  var tmp = $this.kfa_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_3($this, id, $completion) {
  var tmp = $this.ofa_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_4($this, id, $completion) {
  var tmp = $this.qfa_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_5($this, id, $completion) {
  var tmp = $this.tfa_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_6($this, id, $completion) {
  var tmp = $this.xfa_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_7($this, id, $completion) {
  var tmp = $this.zfa_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_8($this, id, $completion) {
  var tmp = $this.cfb_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_9($this, id, $completion) {
  var tmp = $this.efb_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_10($this, id, $completion) {
  var tmp = $this.hfb_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_11($this, id, $completion) {
  var tmp = $this.kfb_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_12($this, id, $completion) {
  var tmp = $this.mfb_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_13($this, id, $completion) {
  var tmp = $this.ofb_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_14($this, id, $completion) {
  var tmp = $this.sfb_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_15($this, id, $completion) {
  var tmp = $this.wfb_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_16($this, id, $completion) {
  var tmp = $this.afc_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_17($this, id, $completion) {
  var tmp = $this.efc_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_18($this, id, $completion) {
  var tmp = $this.gfc_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_19($this, id, $completion) {
  var tmp = $this.ifc_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_20($this, id, $completion) {
  var tmp = $this.mfc_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_21($this, id, $completion) {
  var tmp = $this.qfc_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_22($this, id, $completion) {
  var tmp = $this.sfc_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_23($this, id, $completion) {
  var tmp = $this.vfc_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_24($this, id, $completion) {
  var tmp = $this.xfc_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_25($this, id, $completion) {
  var tmp = $this.bfd_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_26($this, id, $completion) {
  var tmp = $this.ffd_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_27($this, id, $completion) {
  var tmp = $this.hfd_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_28($this, id, $completion) {
  var tmp = $this.lfd_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_29($this, id, $completion) {
  var tmp = $this.pfd_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_30($this, id, $completion) {
  var tmp = $this.tfd_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_31($this, id, $completion) {
  var tmp = $this.wfd_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_32($this, id, $completion) {
  var tmp = $this.afe_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_33($this, id, $completion) {
  var tmp = $this.dfe_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_34($this, id, $completion) {
  var tmp = $this.gfe_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_35($this, id, $completion) {
  var tmp = $this.kfe_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_36($this, id, $completion) {
  var tmp = $this.ofe_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_37($this, id, $completion) {
  var tmp = $this.rfe_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_38($this, id, $completion) {
  var tmp = $this.tfe_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_39($this, id, $completion) {
  var tmp = $this.wfe_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_terminateSession__vfalvx($this, $completion) {
  var tmp = $this.aff_1.zei($completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_delete__spiywt_40($this, id, $completion) {
  var tmp = $this.cff_1.fek(id, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
var Api2AdminReportsLiveClass;
function Api2AdminReportsLive() {
  if (Api2AdminReportsLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.eff_1 = $outer;
      }
      fff($completion) {
        return this.eff_1.gff_1.fei('admin/total-in-escrow', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_instance.m2a(), $completion);
      }
      dfh($completion) {
        return this.eff_1.gff_1.fei('admin/contractor-payable', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_instance.m2a(), $completion);
      }
      efh($completion) {
        return this.eff_1.gff_1.fei('admin/project-escrow', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_instance.m2a(), $completion);
      }
      ffh(input, $completion) {
        return this.eff_1.gff_1.fei('admin/snapshot/contractor', HttpMethod_POST_getInstance(), Companion_getInstance_8().m2a(), input, ListSerializer(Companion_getInstance_9().m2a()), $completion);
      }
      gfh(input, $completion) {
        return this.eff_1.gff_1.fei('admin/snapshot/homeowner', HttpMethod_POST_getInstance(), Companion_getInstance_10().m2a(), input, ListSerializer(Companion_getInstance_11().m2a()), $completion);
      }
      hfh(input, $completion) {
        return this.eff_1.gff_1.fei('admin/transactions', HttpMethod_POST_getInstance(), Companion_getInstance_12().m2a(), input, ListSerializer(Companion_getInstance_13().m2a()), $completion);
      }
    }
    initMetadataForClass($, 'Api2AdminReportsLive', VOID, VOID, VOID, [0, 1]);
    Api2AdminReportsLiveClass = $;
  }
  return Api2AdminReportsLiveClass;
}
var Api2ApprovedStateLiveClass;
function Api2ApprovedStateLive() {
  if (Api2ApprovedStateLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.dfa_1 = $outer;
        this.cfa_1 = new (ClientModelRestEndpointsLive())(this.dfa_1.gff_1, 'approved-states/rest', Companion_getInstance_14().m2a(), Companion_getInstance_49().m2a());
      }
      ifh(input, $completion) {
        return this.cfa_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.ifh(input, $completion);
      }
      jfh(input, $completion) {
        return this.cfa_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.jfh(input, $completion);
      }
      kfh(input, $completion) {
        return this.cfa_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.kfh(input instanceof ApprovedState() ? input : THROW_CCE(), $completion);
      }
      lfh(input, $completion) {
        return this.cfa_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.lfh(input, $completion);
      }
      mfh(id, input, $completion) {
        return this.cfa_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.mfh(id instanceof State() ? id : THROW_CCE(), input, $completion);
      }
      nfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.nfh(id instanceof State() ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2ApprovedStateLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 0, 1]);
    Api2ApprovedStateLiveClass = $;
  }
  return Api2ApprovedStateLiveClass;
}
var Api2ChangeRequestLiveClass;
function Api2ChangeRequestLive() {
  if (Api2ChangeRequestLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.hfa_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_15().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.efa_1 = new (ClientModelRestEndpointsLive())(this.hfa_1.gff_1, 'change-requests/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.ffa_1 = new (HasReadByEndpointsLive())(this.hfa_1.gff_1, 'change-requests/rest', Companion_getInstance_15().m2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_15().m2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.gfa_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.hfa_1.gff_1, 'change-requests/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      ofh(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.hfa_1.gff_1.fei('change-requests/rest/' + tmp$ret$3 + '/publish', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_15().m2a(), $completion);
      }
      pfh(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.hfa_1.gff_1.fei('change-requests/rest/' + tmp$ret$3 + '/un-publish', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_15().m2a(), $completion);
      }
      qfh(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.hfa_1.gff_1.fei('change-requests/rest/' + tmp$ret$3 + '/approved-linked', HttpMethod_POST_getInstance(), serializer_0(StringCompanionObject_instance), input, serializer(Unit_instance), $completion);
      }
      rfh(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.hfa_1.gff_1.fei('change-requests/rest/' + tmp$ret$3 + '/deny-linked', HttpMethod_POST_getInstance(), Companion_getInstance().m2a(), input, serializer(Unit_instance), $completion);
      }
      sfh(input, $completion) {
        return this.efa_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.sfh(input, $completion);
      }
      tfh(input, $completion) {
        return this.efa_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.tfh(input, $completion);
      }
      ufh(input, $completion) {
        return this.efa_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.ufh(input instanceof ChangeRequest() ? input : THROW_CCE(), $completion);
      }
      vfh(input, $completion) {
        return this.efa_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.vfh(input, $completion);
      }
      wfh(id, input, $completion) {
        return this.efa_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.wfh(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_0.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      yfh(input, $completion) {
        return this.efa_1.lek(input, $completion);
      }
      tf9(input, $completion) {
        return this.ffa_1.tf9(input, $completion);
      }
      rek() {
        return this.gfa_1.rek();
      }
    }
    initMetadataForClass($, 'Api2ChangeRequestLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 1, 0]);
    Api2ChangeRequestLiveClass = $;
  }
  return Api2ChangeRequestLiveClass;
}
var Api2ClientLiveClass;
function Api2ClientLive() {
  if (Api2ClientLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.jfa_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_16().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.ifa_1 = new (ClientModelRestEndpointsLive())(this.jfa_1.gff_1, 'clients/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
      }
      zfh(input, $completion) {
        return this.ifa_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.zfh(input, $completion);
      }
      afi(input, $completion) {
        return this.ifa_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.afi(input, $completion);
      }
      bfi(input, $completion) {
        return this.ifa_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.bfi(input instanceof Client() ? input : THROW_CCE(), $completion);
      }
      cfi(input, $completion) {
        return this.ifa_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.cfi(input, $completion);
      }
      dfi(id, input, $completion) {
        return this.ifa_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.dfi(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_1.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2ClientLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 0, 1]);
    Api2ClientLiveClass = $;
  }
  return Api2ClientLiveClass;
}
var Api2CompletionMessageCommentLiveClass;
function Api2CompletionMessageCommentLive() {
  if (Api2CompletionMessageCommentLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.nfa_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_17().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.kfa_1 = new (ClientModelRestEndpointsLive())(this.nfa_1.gff_1, 'completion-message-comments/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.lfa_1 = new (HasReadByEndpointsLive())(this.nfa_1.gff_1, 'completion-message-comments/rest', Companion_getInstance_17().m2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_17().m2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.mfa_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.nfa_1.gff_1, 'completion-message-comments/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      efi(input, $completion) {
        return this.kfa_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.efi(input, $completion);
      }
      ffi(input, $completion) {
        return this.kfa_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.ffi(input, $completion);
      }
      gfi(input, $completion) {
        return this.kfa_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.gfi(input instanceof CompletionMessageComment() ? input : THROW_CCE(), $completion);
      }
      hfi(input, $completion) {
        return this.kfa_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.hfi(input, $completion);
      }
      ifi(id, input, $completion) {
        return this.kfa_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.ifi(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_2.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      tf9(input, $completion) {
        return this.lfa_1.tf9(input, $completion);
      }
      rek() {
        return this.mfa_1.rek();
      }
    }
    initMetadataForClass($, 'Api2CompletionMessageCommentLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2CompletionMessageCommentLiveClass = $;
  }
  return Api2CompletionMessageCommentLiveClass;
}
var Api2ContractorLiveClass;
function Api2ContractorLive() {
  if (Api2ContractorLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.pfa_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_18().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.ofa_1 = new (ClientModelRestEndpointsLive())(this.pfa_1.gff_1, 'contractors/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
      }
      jfi($completion) {
        return this.pfa_1.gff_1.fei('contractors/rest/file-upload-url', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_instance_9.m2a(), $completion);
      }
      kfi(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.pfa_1.gff_1.fei('contractors/rest/' + tmp$ret$3 + '/submit-for-approval', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_18().m2a(), $completion);
      }
      lfi(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.pfa_1.gff_1.fei('contractors/rest/' + tmp$ret$3 + '/financial-setup-token', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, serializer_0(StringCompanionObject_instance), $completion);
      }
      mfi(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.pfa_1.gff_1.fei('contractors/rest/' + tmp$ret$3 + '/setup-direct-payment-info', HttpMethod_POST_getInstance(), Companion_instance_0.m2a(), input, Companion_getInstance_0().m2a(), $completion);
      }
      nfi(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.pfa_1.gff_1.fei('contractors/rest/' + tmp$ret$3 + '/verify-direct-payment-info', HttpMethod_POST_getInstance(), Companion_getInstance_1().m2a(), input, Companion_getInstance_0().m2a(), $completion);
      }
      ofi(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.pfa_1.gff_1.fei('contractors/rest/' + tmp$ret$3 + '/clear-direct-payment-info', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, serializer(Unit_instance), $completion);
      }
      pfi(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.pfa_1.gff_1.fei('contractors/rest/' + tmp$ret$3 + '/clear-payment-info', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, serializer(Unit_instance), $completion);
      }
      qfi(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.pfa_1.gff_1.fei('contractors/rest/' + tmp$ret$3 + '/payment-info', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, get_nullable(Companion_getInstance_0().m2a()), $completion);
      }
      rfi(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.pfa_1.gff_1.fei('contractors/rest/' + tmp$ret$3 + '/pending-cash-out', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_instance_1.m2a(), $completion);
      }
      sfi(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.pfa_1.gff_1.fei('contractors/rest/' + tmp$ret$3 + '/request-cash-out', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, serializer(Unit_instance), $completion);
      }
      tfi(input, $completion) {
        return this.pfa_1.gff_1.fei('contractors/rest/register', HttpMethod_POST_getInstance(), Companion_instance_2.m2a(), input, serializer(Unit_instance), $completion);
      }
      ufi(input, $completion) {
        return this.ofa_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.ufi(input, $completion);
      }
      vfi(input, $completion) {
        return this.ofa_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.vfi(input, $completion);
      }
      wfi(input, $completion) {
        return this.ofa_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.wfi(input instanceof Contractor() ? input : THROW_CCE(), $completion);
      }
      xfi(input, $completion) {
        return this.ofa_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.xfi(input, $completion);
      }
      yfi(id, input, $completion) {
        return this.ofa_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.yfi(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_3.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2ContractorLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 0, 1]);
    Api2ContractorLiveClass = $;
  }
  return Api2ContractorLiveClass;
}
var Api2ContractorDocumentLiveClass;
function Api2ContractorDocumentLive() {
  if (Api2ContractorDocumentLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.sfa_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_19().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.qfa_1 = new (ClientModelRestEndpointsLive())(this.sfa_1.gff_1, 'contractor-documents/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_19().m2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.rfa_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.sfa_1.gff_1, 'contractor-documents/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      zfi(input, $completion) {
        return this.qfa_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.zfi(input, $completion);
      }
      afj(input, $completion) {
        return this.qfa_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.afj(input, $completion);
      }
      bfj(input, $completion) {
        return this.qfa_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.bfj(input instanceof ContractorDocument() ? input : THROW_CCE(), $completion);
      }
      cfj(input, $completion) {
        return this.qfa_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.cfj(input, $completion);
      }
      dfj(id, input, $completion) {
        return this.qfa_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.dfj(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_4.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      rek() {
        return this.rfa_1.rek();
      }
    }
    initMetadataForClass($, 'Api2ContractorDocumentLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2ContractorDocumentLiveClass = $;
  }
  return Api2ContractorDocumentLiveClass;
}
var Api2ContractorNoteLiveClass;
function Api2ContractorNoteLive() {
  if (Api2ContractorNoteLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.wfa_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_20().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.tfa_1 = new (ClientModelRestEndpointsLive())(this.wfa_1.gff_1, 'contractor-notes/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.ufa_1 = new (HasReadByEndpointsLive())(this.wfa_1.gff_1, 'contractor-notes/rest', Companion_getInstance_20().m2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_20().m2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.vfa_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.wfa_1.gff_1, 'contractor-notes/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      efj(input, $completion) {
        return this.tfa_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.efj(input, $completion);
      }
      ffj(input, $completion) {
        return this.tfa_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.ffj(input, $completion);
      }
      gfj(input, $completion) {
        return this.tfa_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.gfj(input instanceof ContractorNote() ? input : THROW_CCE(), $completion);
      }
      hfj(input, $completion) {
        return this.tfa_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.hfj(input, $completion);
      }
      ifj(id, input, $completion) {
        return this.tfa_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.ifj(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_5.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      tf9(input, $completion) {
        return this.ufa_1.tf9(input, $completion);
      }
      rek() {
        return this.vfa_1.rek();
      }
    }
    initMetadataForClass($, 'Api2ContractorNoteLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2ContractorNoteLiveClass = $;
  }
  return Api2ContractorNoteLiveClass;
}
var Api2CrowPayLegalDocumentLiveClass;
function Api2CrowPayLegalDocumentLive() {
  if (Api2CrowPayLegalDocumentLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.yfa_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_21().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.xfa_1 = new (ClientModelRestEndpointsLive())(this.yfa_1.gff_1, 'legal-documents/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
      }
      jfj(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.yfa_1.gff_1.fei('legal-documents/rest/' + tmp$ret$3 + '/email', HttpMethod_POST_getInstance(), Companion_getInstance_50().m2a(), new (EmailAddress())(input), serializer(Unit_instance), $completion);
      }
      kfj(input, $completion) {
        return this.xfa_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.kfj(input, $completion);
      }
      lfj(input, $completion) {
        return this.xfa_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.lfj(input, $completion);
      }
      mfj(input, $completion) {
        return this.xfa_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.mfj(input instanceof CrowPayLegalDocument() ? input : THROW_CCE(), $completion);
      }
      nfj(input, $completion) {
        return this.xfa_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.nfj(input, $completion);
      }
      ofj(id, input, $completion) {
        return this.xfa_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.ofj(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_6.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2CrowPayLegalDocumentLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 0, 1]);
    Api2CrowPayLegalDocumentLiveClass = $;
  }
  return Api2CrowPayLegalDocumentLiveClass;
}
var Api2DebugLiveClass;
function Api2DebugLive() {
  if (Api2DebugLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.pfj_1 = $outer;
      }
      qfj(ScheduleName, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, ScheduleName);
        return this.pfj_1.gff_1.fei('debug/schedules/' + tmp$ret$3, HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, serializer(Unit_instance), $completion);
      }
      rfj(ReportType_0, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(ReportType()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, ReportType_0);
        return this.pfj_1.gff_1.fei('debug/schedules/payouts/' + tmp$ret$3, HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, serializer(Unit_instance), $completion);
      }
    }
    initMetadataForClass($, 'Api2DebugLive', VOID, VOID, VOID, [1]);
    Api2DebugLiveClass = $;
  }
  return Api2DebugLiveClass;
}
var Api2DisputeLiveClass;
function Api2DisputeLive() {
  if (Api2DisputeLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.bfb_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_22().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.zfa_1 = new (ClientModelRestEndpointsLive())(this.bfb_1.gff_1, 'disputes/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_22().m2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.afb_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.bfb_1.gff_1, 'disputes/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      sfj(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.bfb_1.gff_1.fei('disputes/rest/' + tmp$ret$3 + '/lock-project', HttpMethod_PATCH_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_22().m2a(), $completion);
      }
      tfj(input, $completion) {
        return this.zfa_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.tfj(input, $completion);
      }
      ufj(input, $completion) {
        return this.zfa_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.ufj(input, $completion);
      }
      vfj(input, $completion) {
        return this.zfa_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.vfj(input instanceof Dispute() ? input : THROW_CCE(), $completion);
      }
      wfj(input, $completion) {
        return this.zfa_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.wfj(input, $completion);
      }
      xfj(id, input, $completion) {
        return this.zfa_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.xfj(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_7.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      rek() {
        return this.afb_1.rek();
      }
    }
    initMetadataForClass($, 'Api2DisputeLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 1, 0]);
    Api2DisputeLiveClass = $;
  }
  return Api2DisputeLiveClass;
}
var Api2EmailProofLiveClass;
function Api2EmailProofLive() {
  if (Api2EmailProofLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.zfj_1 = $outer;
        this.yfj_1 = new (EmailProofClientEndpointsLive())(this.zfj_1.gff_1, 'auth/proof/email');
      }
      eei(input, $completion) {
        return this.yfj_1.eei(input, $completion);
      }
      gei(input, $completion) {
        return this.yfj_1.gei(input, $completion);
      }
    }
    initMetadataForClass($, 'Api2EmailProofLive', VOID, VOID, VOID, [1]);
    Api2EmailProofLiveClass = $;
  }
  return Api2EmailProofLiveClass;
}
var Api2EntityTypeLiveClass;
function Api2EntityTypeLive() {
  if (Api2EntityTypeLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.dfb_1 = $outer;
        this.cfb_1 = new (ClientModelRestEndpointsLive())(this.dfb_1.gff_1, 'entity-types/rest', Companion_instance_6.m2a(), serializer_0(StringCompanionObject_instance));
      }
      afk(input, $completion) {
        return this.cfb_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.afk(input, $completion);
      }
      bfk(input, $completion) {
        return this.cfb_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.bfk(input, $completion);
      }
      cfk(input, $completion) {
        return this.cfb_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.cfk(input instanceof EntityType() ? input : THROW_CCE(), $completion);
      }
      dfk(input, $completion) {
        return this.cfb_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.dfk(input, $completion);
      }
      efk(id, input, $completion) {
        return this.cfb_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.efk(typeof id === 'string' ? id : THROW_CCE(), input, $completion);
      }
      ffk(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_8.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.ffk(typeof id === 'string' ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2EntityTypeLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 0, 1]);
    Api2EntityTypeLiveClass = $;
  }
  return Api2EntityTypeLiveClass;
}
var Api2EventSubscriptionLiveClass;
function Api2EventSubscriptionLive() {
  if (Api2EventSubscriptionLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.gfb_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_51();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        var tmp_2 = tmp_0.e8k(ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        var tmp_3 = Companion_getInstance_52();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp.efb_1 = new (ClientModelRestEndpointsLive())(this.gfb_1.gff_1, 'notifications/subscriptions/rest', tmp_2, tmp_3.e8k(ContextualSerializer().zy(tmp_4, null, tmp$ret$5)));
        var tmp_5 = this;
        var tmp_6 = Companion_getInstance_51();
        var tmp_7 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$8 = [];
        var tmp_8 = tmp_6.e8k(ContextualSerializer().zy(tmp_7, null, tmp$ret$8));
        var tmp_9 = Companion_getInstance_52();
        var tmp_10 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$11 = [];
        tmp_5.ffb_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.gfb_1.gff_1, 'notifications/subscriptions/rest', tmp_8, tmp_9.e8k(ContextualSerializer().zy(tmp_10, null, tmp$ret$11)));
      }
      gfk(input, $completion) {
        return this.efb_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.gfk(input, $completion);
      }
      hfk(input, $completion) {
        return this.efb_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.hfk(input, $completion);
      }
      ifk(input, $completion) {
        return this.efb_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.ifk(input instanceof EventSubscription() ? input : THROW_CCE(), $completion);
      }
      jfk(input, $completion) {
        return this.efb_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.jfk(input, $completion);
      }
      kfk(id, input, $completion) {
        return this.efb_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.kfk(id instanceof UserEventType() ? id : THROW_CCE(), input, $completion);
      }
      lfk(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_9.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.lfk(id instanceof UserEventType() ? id : THROW_CCE(), $completion);
      }
      rek() {
        return this.ffb_1.rek();
      }
    }
    initMetadataForClass($, 'Api2EventSubscriptionLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2EventSubscriptionLiveClass = $;
  }
  return Api2EventSubscriptionLiveClass;
}
var Api2FundsRequestLiveClass;
function Api2FundsRequestLive() {
  if (Api2FundsRequestLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.jfb_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_23().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.hfb_1 = new (ClientModelRestEndpointsLive())(this.jfb_1.gff_1, 'funds-requests/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_23().m2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.ifb_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.jfb_1.gff_1, 'funds-requests/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      mfk(input, $completion) {
        return this.hfb_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.mfk(input, $completion);
      }
      nfk(input, $completion) {
        return this.hfb_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.nfk(input, $completion);
      }
      ofk(input, $completion) {
        return this.hfb_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.ofk(input instanceof FundsRequest() ? input : THROW_CCE(), $completion);
      }
      pfk(input, $completion) {
        return this.hfb_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.pfk(input, $completion);
      }
      qfk(id, input, $completion) {
        return this.hfb_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.qfk(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_10.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      rek() {
        return this.ifb_1.rek();
      }
    }
    initMetadataForClass($, 'Api2FundsRequestLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2FundsRequestLiveClass = $;
  }
  return Api2FundsRequestLiveClass;
}
var Api2FunnelInstanceLiveClass;
function Api2FunnelInstanceLive() {
  if (Api2FunnelInstanceLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.lfb_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_54().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.kfb_1 = new (ClientModelRestEndpointsLive())(this.lfb_1.gff_1, 'meta/funnels/instance/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
      }
      rfk(input, $completion) {
        return this.kfb_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.rfk(input, $completion);
      }
      sfk(input, $completion) {
        return this.kfb_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.sfk(input, $completion);
      }
      tfk(input, $completion) {
        return this.kfb_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.tfk(input instanceof FunnelInstance() ? input : THROW_CCE(), $completion);
      }
      ufk(input, $completion) {
        return this.kfb_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.ufk(input, $completion);
      }
      vfk(id, input, $completion) {
        return this.kfb_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.vfk(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_11.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2FunnelInstanceLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 1, 0]);
    Api2FunnelInstanceLiveClass = $;
  }
  return Api2FunnelInstanceLiveClass;
}
var Api2FunnelSummaryLiveClass;
function Api2FunnelSummaryLive() {
  if (Api2FunnelSummaryLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.nfb_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_55().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.mfb_1 = new (ClientModelRestEndpointsLive())(this.nfb_1.gff_1, 'meta/funnels/summary/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
      }
      wfk(input, $completion) {
        return this.mfb_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.wfk(input, $completion);
      }
      xfk(input, $completion) {
        return this.mfb_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.xfk(input, $completion);
      }
      yfk(input, $completion) {
        return this.mfb_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.yfk(input instanceof FunnelSummary() ? input : THROW_CCE(), $completion);
      }
      zfk(input, $completion) {
        return this.mfb_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.zfk(input, $completion);
      }
      afl(id, input, $completion) {
        return this.mfb_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.afl(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_12.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2FunnelSummaryLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 0, 1]);
    Api2FunnelSummaryLiveClass = $;
  }
  return Api2FunnelSummaryLiveClass;
}
var Api2IncidentLiveClass;
function Api2IncidentLive() {
  if (Api2IncidentLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.rfb_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_24().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.ofb_1 = new (ClientModelRestEndpointsLive())(this.rfb_1.gff_1, 'incidents/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.pfb_1 = new (HasReadByEndpointsLive())(this.rfb_1.gff_1, 'incidents/rest', Companion_getInstance_24().m2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_24().m2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.qfb_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.rfb_1.gff_1, 'incidents/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      jfi($completion) {
        return this.rfb_1.gff_1.fei('incidents/rest/file-upload-url', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_instance_9.m2a(), $completion);
      }
      bfl(input, $completion) {
        return this.ofb_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.bfl(input, $completion);
      }
      cfl(input, $completion) {
        return this.ofb_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.cfl(input, $completion);
      }
      dfl(input, $completion) {
        return this.ofb_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.dfl(input instanceof Incident() ? input : THROW_CCE(), $completion);
      }
      efl(input, $completion) {
        return this.ofb_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.efl(input, $completion);
      }
      ffl(id, input, $completion) {
        return this.ofb_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.ffl(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_13.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      tf9(input, $completion) {
        return this.pfb_1.tf9(input, $completion);
      }
      rek() {
        return this.qfb_1.rek();
      }
    }
    initMetadataForClass($, 'Api2IncidentLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 1, 0]);
    Api2IncidentLiveClass = $;
  }
  return Api2IncidentLiveClass;
}
var Api2IncidentMessageLiveClass;
function Api2IncidentMessageLive() {
  if (Api2IncidentMessageLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.vfb_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_25().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.sfb_1 = new (ClientModelRestEndpointsLive())(this.vfb_1.gff_1, 'incident-messages/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.tfb_1 = new (HasReadByEndpointsLive())(this.vfb_1.gff_1, 'incident-messages/rest', Companion_getInstance_25().m2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_25().m2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.ufb_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.vfb_1.gff_1, 'incident-messages/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      gfl(input, $completion) {
        return this.vfb_1.gff_1.fei('incident-messages/rest/send-message', HttpMethod_POST_getInstance(), Companion_getInstance_25().m2a(), input, Companion_getInstance_25().m2a(), $completion);
      }
      hfl(input, $completion) {
        return this.sfb_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.hfl(input, $completion);
      }
      ifl(input, $completion) {
        return this.sfb_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.ifl(input, $completion);
      }
      jfl(input, $completion) {
        return this.sfb_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.jfl(input instanceof IncidentMessage() ? input : THROW_CCE(), $completion);
      }
      kfl(input, $completion) {
        return this.sfb_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.kfl(input, $completion);
      }
      lfl(id, input, $completion) {
        return this.sfb_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.lfl(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_14.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      tf9(input, $completion) {
        return this.tfb_1.tf9(input, $completion);
      }
      rek() {
        return this.ufb_1.rek();
      }
    }
    initMetadataForClass($, 'Api2IncidentMessageLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 1, 0]);
    Api2IncidentMessageLiveClass = $;
  }
  return Api2IncidentMessageLiveClass;
}
var Api2IncidentMessageCommentLiveClass;
function Api2IncidentMessageCommentLive() {
  if (Api2IncidentMessageCommentLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.zfb_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_26().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.wfb_1 = new (ClientModelRestEndpointsLive())(this.zfb_1.gff_1, 'incident-message-comments/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.xfb_1 = new (HasReadByEndpointsLive())(this.zfb_1.gff_1, 'incident-message-comments/rest', Companion_getInstance_26().m2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_26().m2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.yfb_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.zfb_1.gff_1, 'incident-message-comments/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      mfl(input, $completion) {
        return this.wfb_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.mfl(input, $completion);
      }
      nfl(input, $completion) {
        return this.wfb_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.nfl(input, $completion);
      }
      ofl(input, $completion) {
        return this.wfb_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.ofl(input instanceof IncidentMessageComment() ? input : THROW_CCE(), $completion);
      }
      pfl(input, $completion) {
        return this.wfb_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.pfl(input, $completion);
      }
      qfl(id, input, $completion) {
        return this.wfb_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.qfl(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_15.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      tf9(input, $completion) {
        return this.xfb_1.tf9(input, $completion);
      }
      rek() {
        return this.yfb_1.rek();
      }
    }
    initMetadataForClass($, 'Api2IncidentMessageCommentLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2IncidentMessageCommentLiveClass = $;
  }
  return Api2IncidentMessageCommentLiveClass;
}
var Api2ItemChangeLiveClass;
function Api2ItemChangeLive() {
  if (Api2ItemChangeLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.dfc_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_27().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.afc_1 = new (ClientModelRestEndpointsLive())(this.dfc_1.gff_1, 'item-changes/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.bfc_1 = new (HasReadByEndpointsLive())(this.dfc_1.gff_1, 'item-changes/rest', Companion_getInstance_27().m2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_27().m2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.cfc_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.dfc_1.gff_1, 'item-changes/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      rfl(input, $completion) {
        return this.afc_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.rfl(input, $completion);
      }
      sfl(input, $completion) {
        return this.afc_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.sfl(input, $completion);
      }
      tfl(input, $completion) {
        return this.afc_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.tfl(input instanceof ItemChange() ? input : THROW_CCE(), $completion);
      }
      ufl(input, $completion) {
        return this.afc_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.ufl(input, $completion);
      }
      vfl(id, input, $completion) {
        return this.afc_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.vfl(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_16.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      tf9(input, $completion) {
        return this.bfc_1.tf9(input, $completion);
      }
      rek() {
        return this.cfc_1.rek();
      }
    }
    initMetadataForClass($, 'Api2ItemChangeLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2ItemChangeLiveClass = $;
  }
  return Api2ItemChangeLiveClass;
}
var Api2LegalDocumentAgreementLiveClass;
function Api2LegalDocumentAgreementLive() {
  if (Api2LegalDocumentAgreementLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.ffc_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_28().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.efc_1 = new (ClientModelRestEndpointsLive())(this.ffc_1.gff_1, 'legal-document-agreements/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
      }
      wfl(input, $completion) {
        return this.efc_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.wfl(input, $completion);
      }
      xfl(input, $completion) {
        return this.efc_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.xfl(input, $completion);
      }
      yfl(input, $completion) {
        return this.efc_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.yfl(input instanceof LegalDocumentAgreement() ? input : THROW_CCE(), $completion);
      }
      zfl(input, $completion) {
        return this.efc_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.zfl(input, $completion);
      }
      afm(id, input, $completion) {
        return this.efc_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.afm(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_17.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2LegalDocumentAgreementLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 0, 1]);
    Api2LegalDocumentAgreementLiveClass = $;
  }
  return Api2LegalDocumentAgreementLiveClass;
}
var Api2LicenseLiveClass;
function Api2LicenseLive() {
  if (Api2LicenseLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.hfc_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_29().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.gfc_1 = new (ClientModelRestEndpointsLive())(this.hfc_1.gff_1, 'licenses/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
      }
      bfm(input, $completion) {
        return this.gfc_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.bfm(input, $completion);
      }
      cfm(input, $completion) {
        return this.gfc_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.cfm(input, $completion);
      }
      dfm(input, $completion) {
        return this.gfc_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.dfm(input instanceof License() ? input : THROW_CCE(), $completion);
      }
      efm(input, $completion) {
        return this.gfc_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.efm(input, $completion);
      }
      ffm(id, input, $completion) {
        return this.gfc_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.ffm(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_18.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2LicenseLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 0, 1]);
    Api2LicenseLiveClass = $;
  }
  return Api2LicenseLiveClass;
}
var Api2LineItemLiveClass;
function Api2LineItemLive() {
  if (Api2LineItemLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.lfc_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_30().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.ifc_1 = new (ClientModelRestEndpointsLive())(this.lfc_1.gff_1, 'line-items/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.jfc_1 = new (HasReadByWithCreditsEndpointsLive())(this.lfc_1.gff_1, 'line-items/rest', Companion_getInstance_30().m2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_30().m2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.kfc_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.lfc_1.gff_1, 'line-items/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      gfm(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.lfc_1.gff_1.fei('line-items/rest/' + tmp$ret$3 + '/force-refresh-state', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, serializer(Unit_instance), $completion);
      }
      jfi($completion) {
        return this.lfc_1.gff_1.fei('line-items/rest/file-upload-url', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_instance_9.m2a(), $completion);
      }
      hfm(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.lfc_1.gff_1.fei('line-items/rest/' + tmp$ret$3 + '/complete', HttpMethod_PATCH_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_30().m2a(), $completion);
      }
      ifm(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.lfc_1.gff_1.fei('line-items/rest/' + tmp$ret$3 + '/add-credit', HttpMethod_PATCH_getInstance(), Companion_getInstance_2().m2a(), input, Companion_getInstance_30().m2a(), $completion);
      }
      jfm(input, $completion) {
        return this.ifc_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.jfm(input, $completion);
      }
      kfm(input, $completion) {
        return this.ifc_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.kfm(input, $completion);
      }
      lfm(input, $completion) {
        return this.ifc_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.lfm(input instanceof LineItem() ? input : THROW_CCE(), $completion);
      }
      mfm(input, $completion) {
        return this.ifc_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.mfm(input, $completion);
      }
      nfm(id, input, $completion) {
        return this.ifc_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.nfm(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_19.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      kek($completion) {
        return this.ifc_1.kek($completion);
      }
      bfa(input, $completion) {
        return this.jfc_1.bfa(input, $completion);
      }
      tf9(input, $completion) {
        return this.jfc_1.tf9(input, $completion);
      }
      rek() {
        return this.kfc_1.rek();
      }
    }
    initMetadataForClass($, 'Api2LineItemLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 1, 0]);
    Api2LineItemLiveClass = $;
  }
  return Api2LineItemLiveClass;
}
var Api2LineItemCompletionMessageLiveClass;
function Api2LineItemCompletionMessageLive() {
  if (Api2LineItemCompletionMessageLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.pfc_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_31().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.mfc_1 = new (ClientModelRestEndpointsLive())(this.pfc_1.gff_1, 'line-item-completion-messages/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.nfc_1 = new (HasReadByEndpointsLive())(this.pfc_1.gff_1, 'line-item-completion-messages/rest', Companion_getInstance_31().m2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_31().m2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.ofc_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.pfc_1.gff_1, 'line-item-completion-messages/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      ofm(input, $completion) {
        return this.pfc_1.gff_1.fei('line-item-completion-messages/rest/send-message', HttpMethod_POST_getInstance(), Companion_getInstance_31().m2a(), input, Companion_getInstance_31().m2a(), $completion);
      }
      jfi($completion) {
        return this.pfc_1.gff_1.fei('line-item-completion-messages/rest/file-upload-url', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_instance_9.m2a(), $completion);
      }
      pfm(input, $completion) {
        return this.mfc_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.pfm(input, $completion);
      }
      qfm(input, $completion) {
        return this.mfc_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.qfm(input, $completion);
      }
      rfm(input, $completion) {
        return this.mfc_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.rfm(input instanceof LineItemCompletionMessage() ? input : THROW_CCE(), $completion);
      }
      sfm(input, $completion) {
        return this.mfc_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.sfm(input, $completion);
      }
      tfm(id, input, $completion) {
        return this.mfc_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.tfm(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_20.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      tf9(input, $completion) {
        return this.nfc_1.tf9(input, $completion);
      }
      rek() {
        return this.ofc_1.rek();
      }
    }
    initMetadataForClass($, 'Api2LineItemCompletionMessageLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 1, 0]);
    Api2LineItemCompletionMessageLiveClass = $;
  }
  return Api2LineItemCompletionMessageLiveClass;
}
var Api2MailCheckPhysicallyLiveClass;
function Api2MailCheckPhysicallyLive() {
  if (Api2MailCheckPhysicallyLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.rfc_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_32().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.qfc_1 = new (ClientModelRestEndpointsLive())(this.rfc_1.gff_1, 'checks/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
      }
      ufm(input, $completion) {
        return this.qfc_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.ufm(input, $completion);
      }
      vfm(input, $completion) {
        return this.qfc_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.vfm(input, $completion);
      }
      wfm(input, $completion) {
        return this.qfc_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.wfm(input instanceof MailCheckPhysically() ? input : THROW_CCE(), $completion);
      }
      xfm(input, $completion) {
        return this.qfc_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.xfm(input, $completion);
      }
      yfm(id, input, $completion) {
        return this.qfc_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.yfm(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_21.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2MailCheckPhysicallyLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 1, 0]);
    Api2MailCheckPhysicallyLiveClass = $;
  }
  return Api2MailCheckPhysicallyLiveClass;
}
var Api2NotificationLiveClass;
function Api2NotificationLive() {
  if (Api2NotificationLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.ufc_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_53();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        var tmp_2 = tmp_0.i8m(ContextualSerializer().zy(tmp_1, null, tmp$ret$2), Companion_getInstance_3().m2a());
        var tmp_3 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp.sfc_1 = new (ClientModelRestEndpointsLive())(this.ufc_1.gff_1, 'notifications/rest', tmp_2, ContextualSerializer().zy(tmp_3, null, tmp$ret$5));
        var tmp_4 = this;
        var tmp_5 = Companion_getInstance_53();
        var tmp_6 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$8 = [];
        var tmp_7 = tmp_5.i8m(ContextualSerializer().zy(tmp_6, null, tmp$ret$8), Companion_getInstance_3().m2a());
        var tmp_8 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$11 = [];
        tmp_4.tfc_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.ufc_1.gff_1, 'notifications/rest', tmp_7, ContextualSerializer().zy(tmp_8, null, tmp$ret$11));
      }
      zfm(input, $completion) {
        return this.sfc_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.zfm(input, $completion);
      }
      afn(input, $completion) {
        return this.sfc_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.afn(input, $completion);
      }
      bfn(input, $completion) {
        return this.sfc_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.bfn(input instanceof Notification() ? input : THROW_CCE(), $completion);
      }
      cfn(input, $completion) {
        return this.sfc_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.cfn(input, $completion);
      }
      dfn(id, input, $completion) {
        return this.sfc_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.dfn(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_22.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      rek() {
        return this.tfc_1.rek();
      }
    }
    initMetadataForClass($, 'Api2NotificationLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2NotificationLiveClass = $;
  }
  return Api2NotificationLiveClass;
}
var Api2OneTimePasswordProofLiveClass;
function Api2OneTimePasswordProofLive() {
  if (Api2OneTimePasswordProofLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.gfn_1 = $outer;
        this.efn_1 = new (AuthenticatedOneTimePasswordProofClientEndpointsLive())(this.gfn_1.gff_1, 'auth/proof/otp');
        this.ffn_1 = new (OneTimePasswordProofClientEndpointsLive())(this.gfn_1.gff_1, 'auth/proof/otp');
      }
    }
    initMetadataForClass($, 'Api2OneTimePasswordProofLive', VOID, VOID, VOID, [1]);
    Api2OneTimePasswordProofLiveClass = $;
  }
  return Api2OneTimePasswordProofLiveClass;
}
var Api2OtpSecretLiveClass;
function Api2OtpSecretLive() {
  if (Api2OtpSecretLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.wfc_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_56().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.vfc_1 = new (ClientModelRestEndpointsLive())(this.wfc_1.gff_1, 'auth/proof/otp/secrets', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
      }
      hfn(input, $completion) {
        return this.vfc_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.hfn(input, $completion);
      }
      ifn(input, $completion) {
        return this.vfc_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.ifn(input, $completion);
      }
      jfn(input, $completion) {
        return this.vfc_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.jfn(input instanceof OtpSecret() ? input : THROW_CCE(), $completion);
      }
      kfn(input, $completion) {
        return this.vfc_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.kfn(input, $completion);
      }
      lfn(id, input, $completion) {
        return this.vfc_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.lfn(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_23.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2OtpSecretLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 0, 1]);
    Api2OtpSecretLiveClass = $;
  }
  return Api2OtpSecretLiveClass;
}
var Api2PayAppItemLiveClass;
function Api2PayAppItemLive() {
  if (Api2PayAppItemLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.afd_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_33().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.xfc_1 = new (ClientModelRestEndpointsLive())(this.afd_1.gff_1, 'pay-app-items/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.yfc_1 = new (HasReadByWithFeedbackEndpointsLive())(this.afd_1.gff_1, 'pay-app-items/rest', Companion_getInstance_33().m2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_33().m2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.zfc_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.afd_1.gff_1, 'pay-app-items/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      mfn(input, $completion) {
        var tmp = HttpMethod_POST_getInstance();
        var tmp_0 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        return this.afd_1.gff_1.fei('pay-app-items/rest/approve-bulk', tmp, ListSerializer(ContextualSerializer().zy(tmp_0, null, tmp$ret$2)), input, serializer(Unit_instance), $completion);
      }
      nfn(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.afd_1.gff_1.fei('pay-app-items/rest/' + tmp$ret$3 + '/deny', HttpMethod_POST_getInstance(), serializer_0(StringCompanionObject_instance), input, serializer(Unit_instance), $completion);
      }
      ofn(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.afd_1.gff_1.fei('pay-app-items/rest/' + tmp$ret$3 + '/void', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_33().m2a(), $completion);
      }
      pfn(input, $completion) {
        return this.xfc_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.pfn(input, $completion);
      }
      qfn(input, $completion) {
        return this.xfc_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.qfn(input, $completion);
      }
      rfn(input, $completion) {
        return this.xfc_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.rfn(input instanceof PayAppItem() ? input : THROW_CCE(), $completion);
      }
      sfn(input, $completion) {
        return this.xfc_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.sfn(input, $completion);
      }
      tfn(id, input, $completion) {
        return this.xfc_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.tfn(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_24.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      xf9(input, $completion) {
        return this.yfc_1.xf9(input, $completion);
      }
      tf9(input, $completion) {
        return this.yfc_1.tf9(input, $completion);
      }
      rek() {
        return this.zfc_1.rek();
      }
    }
    initMetadataForClass($, 'Api2PayAppItemLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 1, 0]);
    Api2PayAppItemLiveClass = $;
  }
  return Api2PayAppItemLiveClass;
}
var Api2PayApplicationLiveClass;
function Api2PayApplicationLive() {
  if (Api2PayApplicationLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.efd_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_34().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.bfd_1 = new (ClientModelRestEndpointsLive())(this.efd_1.gff_1, 'pay-applications/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.cfd_1 = new (HasReadByEndpointsLive())(this.efd_1.gff_1, 'pay-applications/rest', Companion_getInstance_34().m2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_34().m2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.dfd_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.efd_1.gff_1, 'pay-applications/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      jfi($completion) {
        return this.efd_1.gff_1.fei('pay-applications/rest/file-upload-url', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_instance_9.m2a(), $completion);
      }
      ufn(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.efd_1.gff_1.fei('pay-applications/rest/' + tmp$ret$3 + '/submit', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, serializer(Unit_instance), $completion);
      }
      vfn(input, $completion) {
        return this.bfd_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.vfn(input, $completion);
      }
      wfn(input, $completion) {
        return this.bfd_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.wfn(input, $completion);
      }
      xfn(input, $completion) {
        return this.bfd_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.xfn(input instanceof PayApplication() ? input : THROW_CCE(), $completion);
      }
      yfn(input, $completion) {
        return this.bfd_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.yfn(input, $completion);
      }
      zfn(id, input, $completion) {
        return this.bfd_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.zfn(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_25.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      tf9(input, $completion) {
        return this.cfd_1.tf9(input, $completion);
      }
      rek() {
        return this.dfd_1.rek();
      }
    }
    initMetadataForClass($, 'Api2PayApplicationLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2PayApplicationLiveClass = $;
  }
  return Api2PayApplicationLiveClass;
}
var Api2PayoutLiveClass;
function Api2PayoutLive() {
  if (Api2PayoutLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.gfd_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_35().m2a();
        var tmp_1 = getKClass(Instant());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.ffd_1 = new (ClientModelRestEndpointsLive())(this.gfd_1.gff_1, 'payouts/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
      }
      afo(input, $completion) {
        return this.ffd_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.afo(input, $completion);
      }
      bfo(input, $completion) {
        return this.ffd_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.bfo(input, $completion);
      }
      cfo(input, $completion) {
        return this.ffd_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.cfo(input instanceof Payout() ? input : THROW_CCE(), $completion);
      }
      dfo(input, $completion) {
        return this.ffd_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.dfo(input, $completion);
      }
      efo(id, input, $completion) {
        return this.ffd_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.efo(id instanceof Instant() ? id : THROW_CCE(), input, $completion);
      }
      ffo(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_26.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.ffo(id instanceof Instant() ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2PayoutLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 0, 1]);
    Api2PayoutLiveClass = $;
  }
  return Api2PayoutLiveClass;
}
var Api2PendingItemChangeLiveClass;
function Api2PendingItemChangeLive() {
  if (Api2PendingItemChangeLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.kfd_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_36().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.hfd_1 = new (ClientModelRestEndpointsLive())(this.kfd_1.gff_1, 'pending-item-changes/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.ifd_1 = new (HasReadByWithFeedbackEndpointsLive())(this.kfd_1.gff_1, 'pending-item-changes/rest', Companion_getInstance_36().m2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_36().m2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.jfd_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.kfd_1.gff_1, 'pending-item-changes/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      gfo(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.kfd_1.gff_1.fei('pending-item-changes/rest/' + tmp$ret$3 + '/accept', HttpMethod_POST_getInstance(), serializer_0(StringCompanionObject_instance), input, Companion_getInstance_36().m2a(), $completion);
      }
      hfo(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.kfd_1.gff_1.fei('pending-item-changes/rest/' + tmp$ret$3 + '/deny', HttpMethod_POST_getInstance(), Companion_instance_3.m2a(), input, Companion_getInstance_36().m2a(), $completion);
      }
      ifo(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.kfd_1.gff_1.fei('pending-item-changes/rest/' + tmp$ret$3 + '/withdraw', HttpMethod_PATCH_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_36().m2a(), $completion);
      }
      jfo(input, $completion) {
        return this.hfd_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.jfo(input, $completion);
      }
      kfo(input, $completion) {
        return this.hfd_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.kfo(input, $completion);
      }
      lfo(input, $completion) {
        return this.hfd_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.lfo(input instanceof PendingItemChange() ? input : THROW_CCE(), $completion);
      }
      mfo(input, $completion) {
        return this.hfd_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.mfo(input, $completion);
      }
      nfo(id, input, $completion) {
        return this.hfd_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.nfo(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_27.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      xf9(input, $completion) {
        return this.ifd_1.xf9(input, $completion);
      }
      tf9(input, $completion) {
        return this.ifd_1.tf9(input, $completion);
      }
      rek() {
        return this.jfd_1.rek();
      }
    }
    initMetadataForClass($, 'Api2PendingItemChangeLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 1, 0]);
    Api2PendingItemChangeLiveClass = $;
  }
  return Api2PendingItemChangeLiveClass;
}
var Api2PendingLineItemLiveClass;
function Api2PendingLineItemLive() {
  if (Api2PendingLineItemLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.ofd_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_37().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.lfd_1 = new (ClientModelRestEndpointsLive())(this.ofd_1.gff_1, 'pending-line-items/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.mfd_1 = new (HasReadByWithFeedbackEndpointsLive())(this.ofd_1.gff_1, 'pending-line-items/rest', Companion_getInstance_37().m2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_37().m2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.nfd_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.ofd_1.gff_1, 'pending-line-items/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      ofo(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.ofd_1.gff_1.fei('pending-line-items/rest/' + tmp$ret$3 + '/accept', HttpMethod_POST_getInstance(), serializer_0(StringCompanionObject_instance), input, Companion_getInstance_37().m2a(), $completion);
      }
      pfo(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.ofd_1.gff_1.fei('pending-line-items/rest/' + tmp$ret$3 + '/deny', HttpMethod_POST_getInstance(), Companion_instance_3.m2a(), input, Companion_getInstance_37().m2a(), $completion);
      }
      qfo(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.ofd_1.gff_1.fei('pending-line-items/rest/' + tmp$ret$3 + '/withdraw', HttpMethod_PATCH_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_37().m2a(), $completion);
      }
      rfo(input, $completion) {
        return this.lfd_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.rfo(input, $completion);
      }
      sfo(input, $completion) {
        return this.lfd_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.sfo(input, $completion);
      }
      tfo(input, $completion) {
        return this.lfd_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.tfo(input instanceof PendingLineItem() ? input : THROW_CCE(), $completion);
      }
      ufo(input, $completion) {
        return this.lfd_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.ufo(input, $completion);
      }
      vfo(id, input, $completion) {
        return this.lfd_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.vfo(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_28.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      xf9(input, $completion) {
        return this.mfd_1.xf9(input, $completion);
      }
      tf9(input, $completion) {
        return this.mfd_1.tf9(input, $completion);
      }
      rek() {
        return this.nfd_1.rek();
      }
    }
    initMetadataForClass($, 'Api2PendingLineItemLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 1, 0]);
    Api2PendingLineItemLiveClass = $;
  }
  return Api2PendingLineItemLiveClass;
}
var Api2ProjectLiveClass;
function Api2ProjectLive() {
  if (Api2ProjectLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.sfd_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_38().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.pfd_1 = new (ClientModelRestEndpointsLive())(this.sfd_1.gff_1, 'projects/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.qfd_1 = new (HasReadByWithCreditsEndpointsLive())(this.sfd_1.gff_1, 'projects/rest', Companion_getInstance_38().m2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_38().m2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.rfd_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.sfd_1.gff_1, 'projects/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      wfo(project, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, project);
        return this.sfd_1.gff_1.fei('projects/rest/' + tmp$ret$3 + '/add-credit', HttpMethod_POST_getInstance(), Companion_getInstance_2().m2a(), input, serializer(Unit_instance), $completion);
      }
      xfo(project, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, project);
        return this.sfd_1.gff_1.fei('projects/rest/' + tmp$ret$3 + '/force-refresh-state', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_38().m2a(), $completion);
      }
      yfo(project, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, project);
        return this.sfd_1.gff_1.fei('projects/rest/' + tmp$ret$3 + '/cancel', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_38().m2a(), $completion);
      }
      zfo(project, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, project);
        return this.sfd_1.gff_1.fei('projects/rest/' + tmp$ret$3 + '/abandon', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_38().m2a(), $completion);
      }
      afp(project, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, project);
        return this.sfd_1.gff_1.fei('projects/rest/' + tmp$ret$3 + '/publish', HttpMethod_PATCH_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_38().m2a(), $completion);
      }
      bfp(project, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, project);
        return this.sfd_1.gff_1.fei('projects/rest/' + tmp$ret$3 + '/unpublish', HttpMethod_PATCH_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_38().m2a(), $completion);
      }
      cfp(project, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, project);
        return this.sfd_1.gff_1.fei('projects/rest/' + tmp$ret$3 + '/anonymous-link', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, serializer_0(StringCompanionObject_instance), $completion);
      }
      dfp(project, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, project);
        return this.sfd_1.gff_1.fei('projects/rest/' + tmp$ret$3 + '/anonymous-link', HttpMethod_POST_getInstance(), Companion_instance_4.m2a(), input, serializer(Unit_instance), $completion);
      }
      efp(project, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, project);
        return this.sfd_1.gff_1.fei('projects/rest/' + tmp$ret$3 + '/anonymous', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_4().m2a(), $completion);
      }
      ffp(project, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, project);
        return this.sfd_1.gff_1.fei('projects/rest/' + tmp$ret$3 + '/notify-viewed', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_38().m2a(), $completion);
      }
      gfp(project, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, project);
        return this.sfd_1.gff_1.fei('projects/rest/' + tmp$ret$3 + '/accept', HttpMethod_POST_getInstance(), serializer_0(StringCompanionObject_instance), input, Companion_getInstance_38().m2a(), $completion);
      }
      hfp(project, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, project);
        return this.sfd_1.gff_1.fei('projects/rest/' + tmp$ret$3 + '/pay-into-escrow', HttpMethod_POST_getInstance(), Companion_getInstance_57().m2a(), input, get_nullable(Companion_getInstance_39().m2a()), $completion);
      }
      ifp(project, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, project);
        return this.sfd_1.gff_1.fei('projects/rest/' + tmp$ret$3 + '/request-complete', HttpMethod_POST_getInstance(), Companion_getInstance_5().m2a(), input, Companion_getInstance_38().m2a(), $completion);
      }
      jfp(project, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, project);
        return this.sfd_1.gff_1.fei('projects/rest/' + tmp$ret$3 + '/accept-complete', HttpMethod_POST_getInstance(), serializer_0(StringCompanionObject_instance), input, Companion_getInstance_38().m2a(), $completion);
      }
      kfp(project, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, project);
        return this.sfd_1.gff_1.fei('projects/rest/' + tmp$ret$3 + '/request-refunds', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, serializer_1(IntCompanionObject_instance), $completion);
      }
      lfp(project, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, project);
        return this.sfd_1.gff_1.fei('projects/rest/' + tmp$ret$3 + '/request-refunds/check', HttpMethod_POST_getInstance(), Companion_instance_7.m2a(), input, serializer_1(IntCompanionObject_instance), $completion);
      }
      mfp(project, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, project);
        return this.sfd_1.gff_1.fei('projects/rest/' + tmp$ret$3 + '/documents/pay-by-check.html', HttpMethod_POST_getInstance(), Companion_instance.m2a(), new (MonetaryValue())(input), serializer_0(StringCompanionObject_instance), $completion);
      }
      nfp(project, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, project);
        return this.sfd_1.gff_1.fei('projects/rest/' + tmp$ret$3 + '/documents/pay-by-wire.html', HttpMethod_POST_getInstance(), Companion_instance.m2a(), new (MonetaryValue())(input), serializer_0(StringCompanionObject_instance), $completion);
      }
      ofp(project, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, project);
        return this.sfd_1.gff_1.fei('projects/rest/' + tmp$ret$3 + '/pay-into-escrow/external', HttpMethod_POST_getInstance(), Companion_getInstance_40().m2a(), input, serializer(Unit_instance), $completion);
      }
      jfi($completion) {
        return this.sfd_1.gff_1.fei('projects/rest/file-upload-url', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_instance_9.m2a(), $completion);
      }
      pfp(input, $completion) {
        return this.pfd_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.pfp(input, $completion);
      }
      qfp(input, $completion) {
        return this.pfd_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.qfp(input, $completion);
      }
      rfp(input, $completion) {
        return this.pfd_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.rfp(input instanceof Project() ? input : THROW_CCE(), $completion);
      }
      sfp(input, $completion) {
        return this.pfd_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.sfp(input, $completion);
      }
      tfp(id, input, $completion) {
        return this.pfd_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.tfp(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_29.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      ufp(input, $completion) {
        return this.pfd_1.lek(input, $completion);
      }
      vfp(input, $completion) {
        return this.pfd_1.mek(input, $completion);
      }
      bfa(input, $completion) {
        return this.qfd_1.bfa(input, $completion);
      }
      tf9(input, $completion) {
        return this.qfd_1.tf9(input, $completion);
      }
      rek() {
        return this.rfd_1.rek();
      }
    }
    initMetadataForClass($, 'Api2ProjectLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 1, 0]);
    Api2ProjectLiveClass = $;
  }
  return Api2ProjectLiveClass;
}
var Api2ProjectLedgerItemLiveClass;
function Api2ProjectLedgerItemLive() {
  if (Api2ProjectLedgerItemLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.vfd_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_39().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.tfd_1 = new (ClientModelRestEndpointsLive())(this.vfd_1.gff_1, 'project-ledger-items/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_39().m2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.ufd_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.vfd_1.gff_1, 'project-ledger-items/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      wfp(input, $completion) {
        return this.tfd_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.wfp(input, $completion);
      }
      xfp(input, $completion) {
        return this.tfd_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.xfp(input, $completion);
      }
      yfp(input, $completion) {
        return this.tfd_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.yfp(input instanceof ProjectLedgerItem() ? input : THROW_CCE(), $completion);
      }
      zfp(input, $completion) {
        return this.tfd_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.zfp(input, $completion);
      }
      afq(id, input, $completion) {
        return this.tfd_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.afq(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_30.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      rek() {
        return this.ufd_1.rek();
      }
    }
    initMetadataForClass($, 'Api2ProjectLedgerItemLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2ProjectLedgerItemLiveClass = $;
  }
  return Api2ProjectLedgerItemLiveClass;
}
var Api2ProjectMessageLiveClass;
function Api2ProjectMessageLive() {
  if (Api2ProjectMessageLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.zfd_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_41().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.wfd_1 = new (ClientModelRestEndpointsLive())(this.zfd_1.gff_1, 'project-messages/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.xfd_1 = new (HasReadByEndpointsLive())(this.zfd_1.gff_1, 'project-messages/rest', Companion_getInstance_41().m2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_41().m2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.yfd_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.zfd_1.gff_1, 'project-messages/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      bfq(input, $completion) {
        return this.wfd_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.bfq(input, $completion);
      }
      cfq(input, $completion) {
        return this.wfd_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.cfq(input, $completion);
      }
      dfq(input, $completion) {
        return this.wfd_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.dfq(input instanceof ProjectMessage() ? input : THROW_CCE(), $completion);
      }
      efq(input, $completion) {
        return this.wfd_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.efq(input, $completion);
      }
      ffq(id, input, $completion) {
        return this.wfd_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.ffq(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_31.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      tf9(input, $completion) {
        return this.xfd_1.tf9(input, $completion);
      }
      rek() {
        return this.yfd_1.rek();
      }
    }
    initMetadataForClass($, 'Api2ProjectMessageLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2ProjectMessageLiveClass = $;
  }
  return Api2ProjectMessageLiveClass;
}
var Api2ProjectSettlementDocumentationLiveClass;
function Api2ProjectSettlementDocumentationLive() {
  if (Api2ProjectSettlementDocumentationLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.cfe_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_42().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.afe_1 = new (ClientModelRestEndpointsLive())(this.cfe_1.gff_1, 'settlements/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_42().m2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.bfe_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.cfe_1.gff_1, 'settlements/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      jfi($completion) {
        return this.cfe_1.gff_1.fei('settlements/rest/file-upload-url', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_instance_9.m2a(), $completion);
      }
      gfq(input, $completion) {
        return this.afe_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.gfq(input, $completion);
      }
      hfq(input, $completion) {
        return this.afe_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.hfq(input, $completion);
      }
      ifq(input, $completion) {
        return this.afe_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.ifq(input instanceof ProjectSettlementDocumentation() ? input : THROW_CCE(), $completion);
      }
      jfq(input, $completion) {
        return this.afe_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.jfq(input, $completion);
      }
      kfq(id, input, $completion) {
        return this.afe_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.kfq(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_32.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      rek() {
        return this.bfe_1.rek();
      }
    }
    initMetadataForClass($, 'Api2ProjectSettlementDocumentationLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2ProjectSettlementDocumentationLiveClass = $;
  }
  return Api2ProjectSettlementDocumentationLiveClass;
}
var Api2ProjectTimerLiveClass;
function Api2ProjectTimerLive() {
  if (Api2ProjectTimerLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.ffe_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_43().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.dfe_1 = new (ClientModelRestEndpointsLive())(this.ffe_1.gff_1, 'project-timers/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_43().m2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.efe_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.ffe_1.gff_1, 'project-timers/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      lfq($completion) {
        return this.ffe_1.gff_1.fei('project-timers/rest/refresh', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, serializer(Unit_instance), $completion);
      }
      mfq(input, $completion) {
        return this.dfe_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.mfq(input, $completion);
      }
      nfq(input, $completion) {
        return this.dfe_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.nfq(input, $completion);
      }
      ofq(input, $completion) {
        return this.dfe_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.ofq(input instanceof ProjectTimer() ? input : THROW_CCE(), $completion);
      }
      pfq(input, $completion) {
        return this.dfe_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.pfq(input, $completion);
      }
      qfq(id, input, $completion) {
        return this.dfe_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.qfq(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_33.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      rek() {
        return this.efe_1.rek();
      }
    }
    initMetadataForClass($, 'Api2ProjectTimerLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2ProjectTimerLiveClass = $;
  }
  return Api2ProjectTimerLiveClass;
}
var Api2PunchListItemLiveClass;
function Api2PunchListItemLive() {
  if (Api2PunchListItemLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.jfe_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_44().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.gfe_1 = new (ClientModelRestEndpointsLive())(this.jfe_1.gff_1, 'punch-lists-items/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.hfe_1 = new (HasReadByEndpointsLive())(this.jfe_1.gff_1, 'punch-lists-items/rest', Companion_getInstance_44().m2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_44().m2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.ife_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.jfe_1.gff_1, 'punch-lists-items/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      rfq(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.jfe_1.gff_1.fei('punch-lists-items/rest/' + tmp$ret$3 + '/complete', HttpMethod_PATCH_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_44().m2a(), $completion);
      }
      sfq(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.jfe_1.gff_1.fei('punch-lists-items/rest/' + tmp$ret$3 + '/reset', HttpMethod_PATCH_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_44().m2a(), $completion);
      }
      tfq(input, $completion) {
        return this.gfe_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.tfq(input, $completion);
      }
      ufq(input, $completion) {
        return this.gfe_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.ufq(input, $completion);
      }
      vfq(input, $completion) {
        return this.gfe_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.vfq(input instanceof PunchListItem() ? input : THROW_CCE(), $completion);
      }
      wfq(input, $completion) {
        return this.gfe_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.wfq(input, $completion);
      }
      xfq(id, input, $completion) {
        return this.gfe_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.xfq(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_34.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      tf9(input, $completion) {
        return this.hfe_1.tf9(input, $completion);
      }
      rek() {
        return this.ife_1.rek();
      }
    }
    initMetadataForClass($, 'Api2PunchListItemLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 1, 0]);
    Api2PunchListItemLiveClass = $;
  }
  return Api2PunchListItemLiveClass;
}
var Api2ScopeViewLiveClass;
function Api2ScopeViewLive() {
  if (Api2ScopeViewLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.nfe_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_45().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.kfe_1 = new (ClientModelRestEndpointsLive())(this.nfe_1.gff_1, 'scope-views/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        this.lfe_1 = new (HasReadByEndpointsLive())(this.nfe_1.gff_1, 'scope-views/rest', Companion_getInstance_45().m2a());
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_45().m2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.mfe_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.nfe_1.gff_1, 'scope-views/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      yfq(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp = 'scope-views/rest/' + this_0.x27(tmp$ret$1, id) + '/update-items';
        var tmp_0 = HttpMethod_POST_getInstance();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$6 = [];
        return this.nfe_1.gff_1.fei(tmp, tmp_0, ListSerializer(ContextualSerializer().zy(tmp_1, null, tmp$ret$6)), input, serializer(Unit_instance), $completion);
      }
      zfq(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp = 'scope-views/rest/' + this_0.x27(tmp$ret$1, id) + '/add-items';
        var tmp_0 = HttpMethod_POST_getInstance();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$6 = [];
        return this.nfe_1.gff_1.fei(tmp, tmp_0, ListSerializer(ContextualSerializer().zy(tmp_1, null, tmp$ret$6)), input, serializer(Unit_instance), $completion);
      }
      afr(id, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.nfe_1.gff_1.fei('scope-views/rest/' + tmp$ret$3 + '/request-complete', HttpMethod_POST_getInstance(), Companion_getInstance_31().m2a(), input, serializer(Unit_instance), $completion);
      }
      bfr(input, $completion) {
        return this.kfe_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.bfr(input, $completion);
      }
      cfr(input, $completion) {
        return this.kfe_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.cfr(input, $completion);
      }
      dfr(input, $completion) {
        return this.kfe_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.dfr(input instanceof ScopeView() ? input : THROW_CCE(), $completion);
      }
      efr(input, $completion) {
        return this.kfe_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.efr(input, $completion);
      }
      ffr(id, input, $completion) {
        return this.kfe_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.ffr(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_35.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      tf9(input, $completion) {
        return this.lfe_1.tf9(input, $completion);
      }
      rek() {
        return this.mfe_1.rek();
      }
    }
    initMetadataForClass($, 'Api2ScopeViewLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2ScopeViewLiveClass = $;
  }
  return Api2ScopeViewLiveClass;
}
var Api2SmsProofLiveClass;
function Api2SmsProofLive() {
  if (Api2SmsProofLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.hfr_1 = $outer;
        this.gfr_1 = new (SmsProofClientEndpointsLive())(this.hfr_1.gff_1, 'auth/proof/sms');
      }
      nei(input, $completion) {
        return this.gfr_1.nei(input, $completion);
      }
      oei(input, $completion) {
        return this.gfr_1.oei(input, $completion);
      }
    }
    initMetadataForClass($, 'Api2SmsProofLive', VOID, VOID, VOID, [1]);
    Api2SmsProofLiveClass = $;
  }
  return Api2SmsProofLiveClass;
}
var Api2SpecificationLiveClass;
function Api2SpecificationLive() {
  if (Api2SpecificationLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.qfe_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_46().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.ofe_1 = new (ClientModelRestEndpointsLive())(this.qfe_1.gff_1, 'specifications/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_46().m2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.pfe_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.qfe_1.gff_1, 'specifications/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      jfi($completion) {
        return this.qfe_1.gff_1.fei('specifications/rest/file-upload-url', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, Companion_instance_9.m2a(), $completion);
      }
      ifr(input, $completion) {
        return this.ofe_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.ifr(input, $completion);
      }
      jfr(input, $completion) {
        return this.ofe_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.jfr(input, $completion);
      }
      kfr(input, $completion) {
        return this.ofe_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.kfr(input instanceof Specification() ? input : THROW_CCE(), $completion);
      }
      lfr(input, $completion) {
        return this.ofe_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.lfr(input, $completion);
      }
      mfr(id, input, $completion) {
        return this.ofe_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.mfr(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_36.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      rek() {
        return this.pfe_1.rek();
      }
    }
    initMetadataForClass($, 'Api2SpecificationLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 0, 1]);
    Api2SpecificationLiveClass = $;
  }
  return Api2SpecificationLiveClass;
}
var Api2TradeLiveClass;
function Api2TradeLive() {
  if (Api2TradeLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.sfe_1 = $outer;
        this.rfe_1 = new (ClientModelRestEndpointsLive())(this.sfe_1.gff_1, 'trades/rest', Companion_instance_8.m2a(), serializer_0(StringCompanionObject_instance));
      }
      nfr(input, $completion) {
        return this.rfe_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.nfr(input, $completion);
      }
      ofr(input, $completion) {
        return this.rfe_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.ofr(input, $completion);
      }
      pfr(input, $completion) {
        return this.rfe_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.pfr(input instanceof Trade() ? input : THROW_CCE(), $completion);
      }
      qfr(input, $completion) {
        return this.rfe_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.qfr(input, $completion);
      }
      rfr(id, input, $completion) {
        return this.rfe_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.rfr(typeof id === 'string' ? id : THROW_CCE(), input, $completion);
      }
      ffk(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_37.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.ffk(typeof id === 'string' ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2TradeLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 0, 1]);
    Api2TradeLiveClass = $;
  }
  return Api2TradeLiveClass;
}
var Api2UnlockProjectRequestLiveClass;
function Api2UnlockProjectRequestLive() {
  if (Api2UnlockProjectRequestLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.vfe_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_47().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.tfe_1 = new (ClientModelRestEndpointsLive())(this.vfe_1.gff_1, 'unlock-project-requests/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_47().m2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.ufe_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.vfe_1.gff_1, 'unlock-project-requests/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      sfr(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.vfe_1.gff_1.fei('unlock-project-requests/rest/' + tmp$ret$3 + '/accept', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_47().m2a(), $completion);
      }
      tfr(input, $completion) {
        return this.tfe_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.tfr(input, $completion);
      }
      ufr(input, $completion) {
        return this.tfe_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.ufr(input, $completion);
      }
      vfr(input, $completion) {
        return this.tfe_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.vfr(input instanceof UnlockProjectRequest() ? input : THROW_CCE(), $completion);
      }
      wfr(input, $completion) {
        return this.tfe_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.wfr(input, $completion);
      }
      xfr(id, input, $completion) {
        return this.tfe_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.xfr(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_38.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      rek() {
        return this.ufe_1.rek();
      }
    }
    initMetadataForClass($, 'Api2UnlockProjectRequestLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 1, 0]);
    Api2UnlockProjectRequestLiveClass = $;
  }
  return Api2UnlockProjectRequestLiveClass;
}
var Api2UserLiveClass;
function Api2UserLive() {
  if (Api2UserLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.yfe_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_48().m2a();
        var tmp_1 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.wfe_1 = new (ClientModelRestEndpointsLive())(this.yfe_1.gff_1, 'users/rest', tmp_0, ContextualSerializer().zy(tmp_1, null, tmp$ret$2));
        var tmp_2 = this;
        var tmp_3 = Companion_getInstance_48().m2a();
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_2.xfe_1 = new (ClientModelRestEndpointsPlusUpdatesWebsocketLive())(this.yfe_1.gff_1, 'users/rest', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      yfr(input, $completion) {
        return this.yfe_1.gff_1.fei('users/rest/verify-phone-number', HttpMethod_PATCH_getInstance(), Companion_getInstance_58().m2a(), input, Companion_getInstance_59().d2j(Companion_getInstance_48().m2a()), $completion);
      }
      zfr(input, $completion) {
        return this.yfe_1.gff_1.fei('users/rest/add-to-membership', HttpMethod_PATCH_getInstance(), Companion_getInstance_6().m2a(), input, get_nullable(Companion_getInstance_48().m2a()), $completion);
      }
      afs(id, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(getKClass(UUID()), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, id);
        return this.yfe_1.gff_1.fei('users/rest/' + tmp$ret$3 + '/remove-from-membership', HttpMethod_PATCH_getInstance(), serializer(Unit_instance), Unit_instance, Companion_getInstance_48().m2a(), $completion);
      }
      bfs(input, $completion) {
        return this.wfe_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.bfs(input, $completion);
      }
      cfs(input, $completion) {
        return this.wfe_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.cfs(input, $completion);
      }
      dfs(input, $completion) {
        return this.wfe_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.dfs(input instanceof User() ? input : THROW_CCE(), $completion);
      }
      efs(input, $completion) {
        return this.wfe_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.efs(input, $completion);
      }
      ffs(id, input, $completion) {
        return this.wfe_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.ffs(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_39.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
      rek() {
        return this.xfe_1.rek();
      }
    }
    initMetadataForClass($, 'Api2UserLive', VOID, VOID, [ClientModelRestEndpoints(), ClientModelRestEndpointsPlusUpdatesWebsocket()], [2, 1, 0]);
    Api2UserLiveClass = $;
  }
  return Api2UserLiveClass;
}
var Api2UserAuthLiveClass;
function Api2UserAuthLive() {
  if (Api2UserAuthLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.bff_1 = $outer;
        var tmp = this;
        var tmp_0 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        tmp.zfe_1 = new (UserAuthClientEndpointsLive())(this.bff_1.gff_1, 'auth/user', ContextualSerializer().zy(tmp_0, null, tmp$ret$2));
        var tmp_1 = this;
        var tmp_2 = Companion_getInstance_48().m2a();
        var tmp_3 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp_1.aff_1 = new (AuthenticatedUserAuthClientEndpointsLive())(this.bff_1.gff_1, 'auth/user', tmp_2, ContextualSerializer().zy(tmp_3, null, tmp$ret$5));
      }
      gfs(input, $completion) {
        return this.bff_1.gff_1.fei('auth/user/register-start', HttpMethod_POST_getInstance(), Companion_getInstance_7().m2a(), input, serializer_0(StringCompanionObject_instance), $completion);
      }
      hfs(input, $completion) {
        return this.bff_1.gff_1.fei('auth/user/register', HttpMethod_POST_getInstance(), Companion_instance_5.m2a(), input, Companion_getInstance_48().m2a(), $completion);
      }
      ifs($completion) {
        return this.bff_1.gff_1.fei('auth/user/payments/payment-setup', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, serializer_0(StringCompanionObject_instance), $completion);
      }
      jfs($completion) {
        return this.bff_1.gff_1.fei('auth/user/payments/payment-publishable-key', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, serializer_0(StringCompanionObject_instance), $completion);
      }
      kfs($completion) {
        return this.bff_1.gff_1.fei('auth/user/payments', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, ListSerializer(Companion_instance_10.m2a()), $completion);
      }
      lfs(methodId, input, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, methodId);
        return this.bff_1.gff_1.fei('auth/user/payments/' + tmp$ret$3, HttpMethod_PATCH_getInstance(), serializer_0(StringCompanionObject_instance), input, Companion_instance_10.m2a(), $completion);
      }
      mfs(methodId, $completion) {
        // Inline function 'com.lightningkite.serialization.urlifyToCommaString' call
        // Inline function 'kotlinx.serialization.encodeToString' call
        var this_0 = get_DefaultStringArrayFormat();
        // Inline function 'kotlinx.serialization.serializer' call
        var this_1 = this_0.mz();
        // Inline function 'kotlinx.serialization.internal.cast' call
        var this_2 = serializer_2(this_1, createKType(PrimitiveClasses_getInstance().gg(), arrayOf([]), false));
        var tmp$ret$1 = isInterface(this_2, KSerializer()) ? this_2 : THROW_CCE();
        var tmp$ret$3 = this_0.x27(tmp$ret$1, methodId);
        return this.bff_1.gff_1.fei('auth/user/payments/' + tmp$ret$3, HttpMethod_DELETE_getInstance(), serializer(Unit_instance), Unit_instance, serializer(Unit_instance), $completion);
      }
      nfs(input, $completion) {
        return this.bff_1.gff_1.fei('auth/user/payments/setup-direct-payment-info', HttpMethod_POST_getInstance(), Companion_instance_0.m2a(), input, Companion_getInstance_0().m2a(), $completion);
      }
      ofs(input, $completion) {
        return this.bff_1.gff_1.fei('auth/user/payments/verify-direct-payment-info', HttpMethod_POST_getInstance(), Companion_getInstance_1().m2a(), input, Companion_getInstance_0().m2a(), $completion);
      }
      pfs($completion) {
        return this.bff_1.gff_1.fei('auth/user/payments/clear-direct-payment-info', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, serializer(Unit_instance), $completion);
      }
      qfs($completion) {
        return this.bff_1.gff_1.fei('auth/user/payments/clear-payment-info', HttpMethod_POST_getInstance(), serializer(Unit_instance), Unit_instance, serializer(Unit_instance), $completion);
      }
      rfs($completion) {
        return this.bff_1.gff_1.fei('auth/user/payments/direct-payment-info', HttpMethod_GET_getInstance(), serializer(Unit_instance), Unit_instance, get_nullable(Companion_getInstance_0().m2a()), $completion);
      }
      sei(input, $completion) {
        return this.zfe_1.sei(input, $completion);
      }
      tei(input, $completion) {
        return this.zfe_1.tei(input, $completion);
      }
      yei($completion) {
        return this.aff_1.yei($completion);
      }
      zei($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_terminateSession__vfalvx.bind(VOID, this), $completion);
      }
    }
    initMetadataForClass($, 'Api2UserAuthLive', VOID, VOID, VOID, [1, 0, 2]);
    Api2UserAuthLiveClass = $;
  }
  return Api2UserAuthLiveClass;
}
var Api2UserSessionLiveClass;
function Api2UserSessionLive() {
  if (Api2UserSessionLiveClass === VOID) {
    class $ {
      constructor($outer) {
        this.dff_1 = $outer;
        var tmp = this;
        var tmp_0 = Companion_getInstance_60();
        var tmp_1 = Companion_getInstance_48().m2a();
        var tmp_2 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$2 = [];
        var tmp_3 = tmp_0.z2y(tmp_1, ContextualSerializer().zy(tmp_2, null, tmp$ret$2));
        var tmp_4 = getKClass(UUID());
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        var tmp$ret$5 = [];
        tmp.cff_1 = new (ClientModelRestEndpointsLive())(this.dff_1.gff_1, 'auth/user/sessions', tmp_3, ContextualSerializer().zy(tmp_4, null, tmp$ret$5));
      }
      sfs(input, $completion) {
        return this.cff_1.aek(input, $completion);
      }
      aek(input, $completion) {
        return this.sfs(input, $completion);
      }
      tfs(input, $completion) {
        return this.cff_1.bek(input, $completion);
      }
      bek(input, $completion) {
        return this.tfs(input, $completion);
      }
      ufs(input, $completion) {
        return this.cff_1.cek(input, $completion);
      }
      cek(input, $completion) {
        return this.ufs(input instanceof Session() ? input : THROW_CCE(), $completion);
      }
      vfs(input, $completion) {
        return this.cff_1.dek(input, $completion);
      }
      dek(input, $completion) {
        return this.vfs(input, $completion);
      }
      wfs(id, input, $completion) {
        return this.cff_1.eek(id, input, $completion);
      }
      eek(id, input, $completion) {
        return this.wfs(id instanceof UUID() ? id : THROW_CCE(), input, $completion);
      }
      xfh(id, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_delete__spiywt_40.bind(VOID, this, id), $completion);
      }
      fek(id, $completion) {
        return this.xfh(id instanceof UUID() ? id : THROW_CCE(), $completion);
      }
    }
    initMetadataForClass($, 'Api2UserSessionLive', VOID, VOID, [ClientModelRestEndpoints()], [2, 0, 1]);
    Api2UserSessionLiveClass = $;
  }
  return Api2UserSessionLiveClass;
}
var LiveApi2Class;
function LiveApi2() {
  if (LiveApi2Class === VOID) {
    class $ {
      constructor(fetcher) {
        this.gff_1 = fetcher;
        this.hff_1 = new (Api2AdminReportsLive())(this);
        this.iff_1 = new (Api2ApprovedStateLive())(this);
        this.jff_1 = new (Api2ChangeRequestLive())(this);
        this.kff_1 = new (Api2ClientLive())(this);
        this.lff_1 = new (Api2CompletionMessageCommentLive())(this);
        this.mff_1 = new (Api2ContractorLive())(this);
        this.nff_1 = new (Api2ContractorDocumentLive())(this);
        this.off_1 = new (Api2ContractorNoteLive())(this);
        this.pff_1 = new (Api2CrowPayLegalDocumentLive())(this);
        this.qff_1 = new (Api2DebugLive())(this);
        this.rff_1 = new (Api2DisputeLive())(this);
        this.sff_1 = new (Api2EmailProofLive())(this);
        this.tff_1 = new (Api2EntityTypeLive())(this);
        this.uff_1 = new (Api2EventSubscriptionLive())(this);
        this.vff_1 = new (Api2FundsRequestLive())(this);
        this.wff_1 = new (Api2FunnelInstanceLive())(this);
        this.xff_1 = new (Api2FunnelSummaryLive())(this);
        this.yff_1 = new (Api2IncidentLive())(this);
        this.zff_1 = new (Api2IncidentMessageLive())(this);
        this.afg_1 = new (Api2IncidentMessageCommentLive())(this);
        this.bfg_1 = new (Api2ItemChangeLive())(this);
        this.cfg_1 = new (Api2LegalDocumentAgreementLive())(this);
        this.dfg_1 = new (Api2LicenseLive())(this);
        this.efg_1 = new (Api2LineItemLive())(this);
        this.ffg_1 = new (Api2LineItemCompletionMessageLive())(this);
        this.gfg_1 = new (Api2MailCheckPhysicallyLive())(this);
        this.hfg_1 = new (Api2NotificationLive())(this);
        this.ifg_1 = new (Api2OneTimePasswordProofLive())(this);
        this.jfg_1 = new (Api2OtpSecretLive())(this);
        this.kfg_1 = new (Api2PayAppItemLive())(this);
        this.lfg_1 = new (Api2PayApplicationLive())(this);
        this.mfg_1 = new (Api2PayoutLive())(this);
        this.nfg_1 = new (Api2PendingItemChangeLive())(this);
        this.ofg_1 = new (Api2PendingLineItemLive())(this);
        this.pfg_1 = new (Api2ProjectLive())(this);
        this.qfg_1 = new (Api2ProjectLedgerItemLive())(this);
        this.rfg_1 = new (Api2ProjectMessageLive())(this);
        this.sfg_1 = new (Api2ProjectSettlementDocumentationLive())(this);
        this.tfg_1 = new (Api2ProjectTimerLive())(this);
        this.ufg_1 = new (Api2PunchListItemLive())(this);
        this.vfg_1 = new (Api2ScopeViewLive())(this);
        this.wfg_1 = new (Api2SmsProofLive())(this);
        this.xfg_1 = new (Api2SpecificationLive())(this);
        this.yfg_1 = new (Api2TradeLive())(this);
        this.zfg_1 = new (Api2UnlockProjectRequestLive())(this);
        this.afh_1 = new (Api2UserLive())(this);
        this.bfh_1 = new (Api2UserAuthLive())(this);
        this.cfh_1 = new (Api2UserSessionLive())(this);
      }
      req(headerCalculator) {
        return new (LiveApi2())(this.gff_1.req(headerCalculator));
      }
    }
    initMetadataForClass($, 'LiveApi2', VOID, VOID, VOID, [1, 0]);
    LiveApi2Class = $;
  }
  return LiveApi2Class;
}
//region block: exports
export {
  LiveApi2 as LiveApi22p7ep9cwyglni,
};
//endregion

//# sourceMappingURL=LiveApi.mjs.map
